export enum BookingObjectType {
  Desk = 'desk',
  MeetingRoom = 'meetingRoom',
  FocusRoom = 'focusRoom',
  PhoneRoom = 'phoneRoom',
  Parking = 'parking',
}
